import { useState } from 'react';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import BigData from './pages/BigData';
import Java from './pages/Java';
import PowerBI from './pages/PowerBI';
import DevOps from './pages/DevOps';
import LifeScienceServices from './pages/LifeScienceServices';
import HealthcareServices from './pages/HealthcareServices';

function App() {
  const [currentPage, setCurrentPage] = useState('Home');

  const pages = {
    Home: <Home setCurrentPage={setCurrentPage} />,
    AboutUs: <AboutUs setCurrentPage={setCurrentPage} />,
    Careers: <Careers setCurrentPage={setCurrentPage} />,
    Contact: <Contact setCurrentPage={setCurrentPage} />,
    BigData: <BigData setCurrentPage={setCurrentPage} />,
    Java: <Java setCurrentPage={setCurrentPage} />,
    PowerBI: <PowerBI setCurrentPage={setCurrentPage} />,
    DevOps: <DevOps setCurrentPage={setCurrentPage} />,
    LifeScienceServices: <LifeScienceServices setCurrentPage={setCurrentPage} />,
    HealthcareServices: <HealthcareServices setCurrentPage={setCurrentPage} />
  };

  return (
    <div className="App">
      <Header currentPage={currentPage} setCurrentPage={setCurrentPage} />
      {pages[currentPage] || pages['Home']}
      <Footer setCurrentPage={setCurrentPage} />
    </div>
  );
}

export default App;